<template>
  <div class="show-container">
    <div :id="id" style="height: 100%;" v-if="hasData"></div>
    <show-no-data v-else></show-no-data>
  </div>
</template>

<script>
  import eCharts from 'echarts'
  import 'echarts/theme/macarons'
  import analyseUtil from '../analyse-util'
  import ShowNoData from '../show-no-data'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'
  export default {
    components: {
      ShowNoData
    },
    props: {
      data: {
        type: Object
      }
    },
    name: 'scatter-config',
    typeCode: '9',
    data() {
      return {
        id: analyseUtil.randomId(),
        myChart: {},
        options: {
          grid: {
            top: 40,
            left: 20,
            bottom: 10,
            right: 100,
            containLabel: true
          },
          tooltip: {
            showDelay: 0,
            formatter: function (params) {
              if (params.value.length > 1) {
                return params.value[2] + '<br/>' + params.value[0] + '次 <br/>' + params.value[1] + '% '
              } else {
                return params.name + ' ' + params.value
              }
            },
            axisPointer: {
              show: true,
              type: 'cross',
              lineStyle: {
                type: 'dashed',
                width: 1
              }
            }
          },
          xAxis: {name: null},
          yAxis: {
            name: null,
            max: 100
          },
          series: [{
            top: 0,
            bottom: 0,
            left: 0,
            color: analyseUtil.COLORS,
            symbolSize: 5,
            normal: {
              opacity: 0.8
            },
            data: null,
            type: 'scatter'
          }]
        }
      }
    },
    computed: {
      hasData: function () {
        return this.data.data && this.data.data.length > 0
      }
    },
    mounted() {
      if (this.hasData) {
        this.loadChart()
        addResizeListener(this.$el, this.resizeListener)
      }
    },
    beforeDestroy() {
      if (this.hasData) {
        removeResizeListener(this.$el, this.resizeListener)
      }
    },
    methods: {
      resizeListener: function () {
        this.$nextTick(() => {
          if (this.myChart !== null) {
            this.myChart.resize()
          }
        })
      },
      loadChart: function () {
        this.myChart = eCharts.init(document.getElementById(this.id), 'shine')
        this.options.xAxis.name = this.data.extEChartConfig.xAxis.name
        this.options.yAxis.name = this.data.extEChartConfig.yAxis.name
        this.options.series[0].data = []
        for (let i = 0; i < this.data.data.length; i++) {
          this.options.series[0].data.push([this.data.data[i].x, this.data.data[i].y, this.data.data[i].label])
        }
        this.myChart.setOption(this.options)
        this.myChart.hideLoading()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/scatter-config.vue